import React from 'react';
import Button from '../Form/Button';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { getTakeoutModeOptions } from '../../Utils/Constants/Order';
import ButtonPrimary from '../Form/ButtonPrimary';

interface TakeoutModeButtonsProps {
    className?: string;
    onChange?: () => void;
}

const TakeoutModeButtons = ({ className='', onChange }: TakeoutModeButtonsProps) => {

    const { takeoutMode, setTakeoutMode } = useOrderTypeContext();

    const handleChange = (option: string) => {
        setTakeoutMode(option);
        onChange?.();
    }

    return (
        <>
            {   getTakeoutModeOptions().map((item: any, index: number) =>
                    takeoutMode === item.option
                        ?   <ButtonPrimary outline key={index} onClick={() => handleChange(item.option)} className={`flex-1 text-nowrap gap-0.5 pointer-events-none ${className}`}>
                                <div className='text-lg'>{ item.icon }</div>
                                <span>{ item.label }</span>
                            </ButtonPrimary>
                        :   <Button key={index} onClick={() => handleChange(item.option)} className={`flex-1 text-nowrap gap-0.5 ${className}`}>
                                <div className='text-lg'>{ item.icon }</div>
                                <span>{ item.label }</span>
                            </Button>
                )
            }
        </>
    )
}

export default TakeoutModeButtons;